import { AppAction, AppDataState } from '../types';

export const appReducer = (state: AppDataState, action: AppAction): AppDataState => {
  switch (action.type) {
    case 'set-app-loading':
      return { ...state, loading: action.isLoading };

    case 'set-network-status':
      return { ...state, networkStatus: action.networkStatus };

    case 'set-app-data':
      return { ...state, ...action.data };

    case 'set-menu-enabled':
      return { ...state, menuEnabled: action.menuEnabled };

    default:
      return state;
  }
};
